module.exports = __webpack_public_path__ + "img/head-banner.e1700b0d.jpg";